import { render, staticRenderFns } from "./UploadSketchesComponent.vue?vue&type=template&id=0eafc98f&scoped=true&"
import script from "./UploadSketchesComponent.vue?vue&type=script&lang=ts&"
export * from "./UploadSketchesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UploadSketchesComponent.vue?vue&type=style&index=0&id=0eafc98f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eafc98f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardText,VCol,VFileInput,VIcon,VImg})
